module.exports = __webpack_public_path__ + "static/img/service_introduce_9999_zh.c74ec93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_introduce_9999_zh.png
// module id = eDUt
// module chunks = 34